import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
const DirectionValue = (props) => {
    const { item, applyValue } = props;
    const handleFilterChange = (iconPressed) => {
        let original = item.value ?? 'BOTH';
        switch (iconPressed) {
            case 'UP':
                if (original === 'BOTH') {
                    original = 'UP';
                }
                else if (original === 'DOWN') {
                    original = 'BOTH';
                }
                break;
            case 'DOWN':
                if (original === 'BOTH') {
                    original = 'DOWN';
                }
                else if (original === 'UP') {
                    original = 'BOTH';
                }
                break;
        }
        applyValue({
            ...item,
            value: original,
        });
    };
    return (_jsxs(Box, { sx: {
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: 48,
            pl: '20px',
        }, children: [_jsx(IconButton, { onClick: () => handleFilterChange('UP'), children: _jsx(ArrowUpward, { color: item.value !== 'DOWN' ? 'success' : 'disabled' }) }), _jsx(IconButton, { onClick: () => handleFilterChange('DOWN'), children: _jsx(ArrowDownward, { color: item.value !== 'UP' ? 'warning' : 'disabled' }) })] }));
};
export const filterUD = [
    {
        label: 'Show',
        value: 'show',
        getApplyFilterFn: (filterItem) => {
            if (!filterItem.field || !filterItem.value || !filterItem.operator) {
                return null;
            }
            return (value) => {
                if (filterItem.value === 'BOTH')
                    return true;
                return value === filterItem.value;
            };
        },
        InputComponent: DirectionValue,
    },
];
